import React from 'react';

const Operators = () => {
  return <div>operators</div>;
};

export default Operators;
